// src/redux/slices/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  loginUser,
  registerUser,
  forgotPasswordApi,
  resetPasswordApi,
  loginMember
} from '../../services/authService';

import { updateuser as updateUserService } from '../../services/dbService';
import { verifyEmail as verifyEmailService } from '../../services/dbService';
import { register as registermemberService } from '../../services/authService';
import { resetpassword as resetpasswordService } from '../../services/dbService';
import { sendresetpasswordlink as sendresetpasswordlinkService } from '../../services/dbService';
import { editMember as editMemberService } from '../../services/dbService';
import { getByMemberId as  getByMemberIdService} from '../../services/dbService';
import {getMemberAll as getMemberAllService } from '../../services/dbService';
import { savelinked as savelinkedService } from '../../services/dbService';
import { editLinkedList as editLinkedListService } from '../../services/dbService';
import { deletelinkedList as deletelinkedListService } from '../../services/dbService';
import { getlinkedById as getlinkedByIdService } from '../../services/dbService';
import { getByPrimaryMember as  getByPrimaryMemberService} from '../../services/dbService';
import { getLinkedMemberAll as  getLinkedMemberAllService} from '../../services/dbService';


import { savemembershiptypes as savemembershiptypesService } from '../../services/dbService';
import { editmembershiptypes as editmembershiptypesService } from '../../services/dbService';
import { getmembershiptype as getmembershiptypeService } from '../../services/dbService';
import { getallmembershiptypes as getallmembershiptypesService } from '../../services/dbService';


import { savemembershippayment as savemembershippaymentService } from '../../services/dbService';
import { editmembershippayment as editmembershippaymentService } from '../../services/dbService';
import { getmembershippayment as getmembershippaymentService } from '../../services/dbService';
import { getallmembershippayments as getallmembershippaymentsService } from '../../services/dbService';
import { getallmembershippaymentsbydate as getallmembershippaymentsbydateService } from '../../services/dbService';
import { getallmembershippaymentsbymember as getallmembershippaymentsbymemberService } from '../../services/dbService';

import { saveEvent as saveEventService } from '../../services/dbService';
import { getByEventId as getByEventIdService } from '../../services/dbService';
import { editEvent as editEventService } from '../../services/dbService';
import { getEventAll as getEventAllService } from '../../services/dbService';

import { editpackages as editpackagesService } from '../../services/dbService';
import {savepackage as savepackageService }from '../../services/dbService';
import { getpackagebyevent as getpackagebyeventService } from '../../services/dbService';
import { sendcode as sendcodeService } from '../../services/dbService';
import { saveeventregistration as  saveeventregistrationService} from '../../services/dbService';
import { geteventregistrationById as  geteventregistrationByIdService} from '../../services/dbService';
import { getregistrationbyevent as getregistrationbyeventService } from '../../services/dbService';
import { editregistration as editregistrationService } from '../../services/dbService';

import { getregistrationbymail as getregistrationbymailService } from '../../services/dbService';
import { sendverificationLink as sendverificationLinkService } from '../../services/dbService';
import { fetchtransactions as fetchtransactionsService } from '../../services/dbService';
import { getregistrationbymember as getregistrationbymemberService } from '../../services/dbService';
import { getregistrationbydate as getregistrationbydateService } from '../../services/dbService';

const initialState = {
  user: null,
  token: null,
  status: 'idle', // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};


export const verifymail = async (data) => {
  try {
    const formData = new FormData()

    formData.append('token', data)

    const response = await verifyEmailService(formData)
    return response
  }
  catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


// Async Thunks
export const login = createAsyncThunk('user/login', async (credentials, { rejectWithValue }) => {
  try {
    const response = await loginUser(credentials);

    const info = response.data;
    const userData = info.data;
    localStorage.setItem('token', (info.token)); // Save token in localStorage

    //localStorage.setItem('token', JSON.parse(data.data.token));

    localStorage.setItem('id', (userData.id));

    return userData; // Data contains user and token
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Something went wrong');
  }
});

export const loginmember = createAsyncThunk('member/login', async (credentials, { rejectWithValue }) => {
  try {
    const response = await loginMember(credentials);
    debugger

    const info = response.data;
    const userData = info.data;
    localStorage.setItem('token', (info.token));

    localStorage.setItem('id', (userData.id));

    return userData; // Data contains user and token
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Something went wrong');
  }
});

export const register = createAsyncThunk('user/register', async (userData, { rejectWithValue }) => {
  try {
    const data = await registerUser(userData);
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Something went wrong');
  }
});

export const registermember = createAsyncThunk('members/save', async (userData, { rejectWithValue }) => {
  try {
    const data = await registermemberService(userData);

    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Something went wrong');
  }
});

export const forgotPassword = createAsyncThunk(
  'user/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const data = await forgotPasswordApi(email);
      return data; // Success message
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

// export const resetPassword = createAsyncThunk(
//   'user/resetPassword',
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await resetPasswordApi(data);
//       return response; // Success message
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Something went wrong');
//     }
//   }
// );

export const resetPassword = async (data) => {
  try {
    const formData = new FormData()
    formData.append('token', data.token)
    formData.append('password', data.password)
    const response = await resetpasswordService(formData);
    return response; // Success message
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const sendverificationLink = async (id,email) => {
  try {
    const formData = new FormData()
    formData.append('id', id)
    formData.append('email', email)
    const response = await sendverificationLinkService(formData);
    return response; // Success message
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const changepassword = async (data) => {
  try {
    const formData = new FormData()
    formData.append('id', data.id)
    formData.append('password', data.password)
    const response = await editMemberService(formData);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const editMember = async (data) => {
  try {

    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.delete('primarymember')
    const response = await editMemberService(payload);
    
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const getByMemberId = async (data) => {
  try {
    const formData = new FormData()
    formData.append('id', data)
    const response = await getByMemberIdService(formData);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const getMemberAll = async (data) => {
  try {
    const response = await getMemberAllService();
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const resetmemberpassword = createAsyncThunk(
  'user/resetPassword',
  async (data, { rejectWithValue }) => {
    try {
      const response = await resetpasswordService(data);
      return response; // Success message
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const sendmemberresetpasswordlink = createAsyncThunk(
  'user/resetPassword',
  async (data, { rejectWithValue }) => {
    try {
      const response = await sendresetpasswordlinkService(data);
      return response; // Success message
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);



export const savelinked = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.append('status', '1');
    const response = await savelinkedService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const editLinked = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editLinkedListService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const deletelinkedList = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await deletelinkedListService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getlinkedById = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await getlinkedByIdService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getByLinkedMemberByPrimaryMember = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await getByPrimaryMemberService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getLinkedMemberAll= async (data) => {
  try {
    const response = await getLinkedMemberAllService();
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}



export const getallmembershiptypes= async (data) => {
  try {
    const response = await getallmembershiptypesService();
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getmembershiptype = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await getmembershiptypeService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const editmembershiptypes = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editmembershiptypesService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const savemembershiptypes = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await savemembershiptypesService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const getallmembershippayments= async (data) => {
  try {
    const response = await getallmembershippaymentsService();
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getmembershippayment = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await getmembershippaymentService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const editmembershippayment = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.delete('member_name');
    payload.delete('membership_type');

    const response = await editmembershippaymentService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const savemembershippayment = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await savemembershippaymentService(payload);
    return response; 
  } catch (error) {
    console.log('error',error)
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const getallmembershippaymentsbydate = async (startdate,enddate) => {
  try {
    const payload = new FormData()
    payload.append('startdate', startdate)
    payload.append('enddate', enddate)
    const response = await getallmembershippaymentsbydateService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getallmembershippaymentsbymember = async (data) => {
  try {
    const payload = new FormData()
    payload.append('id', data)
    const response = await getallmembershippaymentsbymemberService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

// Slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.status = 'idle';
      localStorage.removeItem('token'); // Clear token on logout
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(login.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        switch (action.payload.status) {
          case 200:
            state.status = 'succeeded';
            state.error = null;
            state.token = action.payload.data?.token;
            state.user = action.payload.data?.data;
            break;

          case 500:
            state.error =
              action.payload?.data?.message || action.payload?.message || "Something went wrong!";
            state.status = 'failed';
            break;

          default:
            break;
        }

      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Register
      .addCase(register.pending, (state) => {
        state.status = 'loading';

      })
      .addCase(register.fulfilled, (state, action) => {
        switch (action.payload.status) {
          case 200:
            state.status = 'succeeded';
            state.error = null;
            state.token = action.payload.data?.data?.token;
            break;

          case 500:
            state.error =
              action.payload?.data?.message || action.payload?.message || "Something went wrong!";
            state.status = 'failed';
            break;

          default:
            break;
        }

      })
      .addCase(register.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Forgot Password
      .addCase(forgotPassword.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.status = 'succeeded';
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
  },
});


export const editEvent = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editEventService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getByEventId = async (data) => {
  try {
    let payload=new FormData();
    
    payload.append('id', data);
    const response = await getByEventIdService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const getEventAll = async (data) => {
  try {
    const response = await getEventAllService();
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}
export const saveeventregistration = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.append('packages', JSON.stringify(data.packages));
    payload.append('members', JSON.stringify(data.members));
    const response = await saveeventregistrationService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const geteventregistrationById = async (data) => {
  try {
    let payload=new FormData();
    
    payload.append('id', data);
    const response = await geteventregistrationByIdService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const getregistrationbyevent = async (data) => {
  try {
    let payload=new FormData();
    
    payload.append('id', data);
    const response = await getregistrationbyeventService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const getregistrationbymember = async (data) => {
  try {
    let payload=new FormData();
    
    payload.append('mail', data);
    const response = await getregistrationbymemberService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const saveEvent = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await saveEventService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const editpackages = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.delete("formattedstartdate")
    payload.delete("formattedenddate")
    const response = await editpackagesService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const savepackage = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    payload.delete("formattedstartdate")
    payload.delete("formattedenddate")
    const response = await savepackageService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const getpackagebyevent = async (data) => {
  try {
    let payload=new FormData();
      payload.append('event', data);
    
    const response = await getpackagebyeventService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const deletepackages = async (data) => {
  try {
    let payload=new FormData();
    payload.append('id', data.id);
    payload.append('status', '0');

    const response = await editpackagesService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const sendcode = async (email,code) => {
  try {
    let payload=new FormData();
    payload.append('email', email);
    payload.append('code', code);

    const response = await sendcodeService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const editregistration = async (data) => {
  try {
    let payload=new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editregistrationService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const getregistrationbymail = async (email,code) => {
  try {
    let payload=new FormData();
    payload.append('email', email);

    const response = await getregistrationbymailService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}



export const getregistrationbydate = async (data,startdate,enddate) => {
  try {
    let payload=new FormData();
    
    payload.append('id', data);
    payload.append('startdate', startdate);
    payload.append('enddate', enddate);
    const response = await getregistrationbydateService(payload);
    return response; 
  } catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}

export const { logout } = userSlice.actions;
export default userSlice.reducer;
